/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Title_ImportingInputs */

const en_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing Project`)
};

const fr_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du projet`)
};

const de_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importprojekt`)
};

const it_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del progetto`)
};

const ru_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект импорта`)
};

const es_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando Proyecto`)
};

const zh_cn2_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入项目`)
};

const ja_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポート`)
};

const hi_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात परियोजना`)
};

const pt_pt2_iframe_remote_title_importing = /** @type {(inputs: Iframe_Remote_Title_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto de Importação`)
};

/**
* | output |
* | --- |
* | "Importing Project" |
*
* @param {Iframe_Remote_Title_ImportingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_title_importing = /** @type {((inputs?: Iframe_Remote_Title_ImportingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Title_ImportingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_title_importing(inputs)
	if (locale === "de") return de_iframe_remote_title_importing(inputs)
	if (locale === "it") return it_iframe_remote_title_importing(inputs)
	if (locale === "ru") return ru_iframe_remote_title_importing(inputs)
	if (locale === "es") return es_iframe_remote_title_importing(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_title_importing(inputs)
	if (locale === "ja") return ja_iframe_remote_title_importing(inputs)
	if (locale === "hi") return hi_iframe_remote_title_importing(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_title_importing(inputs)
	return en_iframe_remote_title_importing(inputs)
});